import * as React from 'react'
import Typography from '@material-ui/core/Typography'

import IOrder from 'src/models/IOrder'

interface IConfirmationProps {
  order: IOrder
}

const Confirmation: React.SFC<IConfirmationProps> = props => {
  const { order } = props

  return (
    <>
      <Typography variant="h5" gutterBottom={true}>
        Thank you for your order, {order.firstName}!
      </Typography>
      <Typography variant="subtitle1">
        Your order number is {order.orderNumber}. An email confirmation will be
        sent to {order.email}
      </Typography>
    </>
  )
}

export default Confirmation



// WEBPACK FOOTER //
// ./src/components/contest/Confirmation.tsx